var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0H4.50063C2.29125 0 0.500406 1.79063 0.500406 4L0.5 24C0.5 26.2094 2.29063 28 4.5 28H18.8438C19.9044 28 20.9219 27.5786 21.6725 26.8281L27.3294 21.1712C28.0812 20.4187 28.5 19.4062 28.5 18.3438V4C28.5 1.79063 26.7062 0 24.5 0ZM20.5 25.1688V21C20.5 20.4482 20.9492 20 21.5 20H25.6719L20.5 25.1688ZM26.5 18H21.5C19.8456 18 18.5 19.3456 18.5 21V26H4.5C3.3975 26 2.5 25.1025 2.5 24V4C2.5 2.8975 3.3975 2 4.5 2H24.5C25.6025 2 26.5 2.8975 26.5 4V18ZM19.5 10H16.5V7C16.5 6.45 16.05 6 15.5 6H13.5C12.95 6 12.5 6.45 12.5 7V10H9.5C8.95 10 8.5 10.45 8.5 10.9438V13C8.5 13.5522 8.94775 13.9438 9.5 13.9438H12.5V16.9438C12.5 17.55 12.95 18 13.5 18H15.5C16.0522 18 16.5 17.5521 16.5 17V13.9438L19.5 13.9437C20.0522 13.9437 20.5 13.496 20.5 12.9999V10.9438C20.5 10.45 20.05 10 19.5 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherIcon);
export default __webpack_public_path__ + "static/media/OtherIcon.381f21f3c92ca9a5bd82384af494592b.svg";
export { ForwardRef as ReactComponent };